var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('PressReleaseModal'),_c('page-header',{attrs:{"heading":"Press Release","action":"Add","toggle":"offcanvas","target":"#offcanvasCreate","guard":this.$route.meta.guard},on:{"click":_vm.setCreateForm}}),_c('PressReleaseTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }